import { render } from "./InvoiceCreateReceiverCard.vue?vue&type=template&id=7117ed66"
import script from "./InvoiceCreateReceiverCard.vue?vue&type=script&lang=js"
export * from "./InvoiceCreateReceiverCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__